import * as React from 'react';
import { Button } from '../atoms/button';

interface UnAuthorizedErrorBoundaryProps {
  children: React.ReactNode;
}

interface UnAuthorizedErrorBoundaryState {
  isUnauthorised: boolean;
}

export class UnAuthorizedErrorBoundary extends React.Component<
  UnAuthorizedErrorBoundaryProps,
  UnAuthorizedErrorBoundaryState
> {
  constructor(props: UnAuthorizedErrorBoundaryProps) {
    super(props);
    this.state = {
      isUnauthorised: false,
    };
  }

  static getDerivedStateFromError(error: unknown): UnAuthorizedErrorBoundaryState {
    const err = error as { status?: number };
    console.log('Status = ' + (err.status ?? 'unknown'));
    if (err.status === 401 || err.status === 403) {
      return {
        isUnauthorised: true,
      };
    }
    return {
      isUnauthorised: false,
    };
  }

  render() {
    if (this.state.isUnauthorised) {
      return <div className="flex flex-col items-center justify-center h-screen">
        <div className="flex flex-col items-center justify-center">
          <img src="/public/shoppy-logo.svg" />
          <h1 className="text-2xl font-bold">Shoppy Admin</h1>
          <div className="mt-4">
            <Button asChild>
              <a href="/api/login">Login</a>
            </Button>
          </div>
        </div>
      </div>;
    }
    return this.props.children;
  }
}

export default UnAuthorizedErrorBoundary;
